import { Injectable } from '@angular/core';

/**
 * Handles modal interactions.
 */
@Injectable({
  providedIn: 'root'
})
export class ClubOverviewService {
  public listOfModals: any = {
    editClubModal: false,
    editClubDataModal: false,
    editClubCommunicationModal: false,
    editClubAddressModal: false,
    editClubBankDataModal: false,
    editLogoModal: false,
    editModulesModal: false,
    editWebhookModal: false,
    createWebhookModal: false,
    editWebsiteModal: false,
    editTixxConnect: false,
    editCampaign: false,
    editTixxSelect: false,
    editFanScoreCard: false,
    editTixxWebshop: false,
    editCampaiMembership: false,
    editClubGdprSettingsModal: false,
  };

  public disableModal: boolean = false;

  public updateLoading: boolean = false;

  constructor() { }

  /**
   * Set the status to all modals.
   */
  public toggleAllModal(status: boolean): any {
    this.toggleEditClubModal(status);
    this.togleEditLogoModal(status);
    this.togleEditModulesModal(status);
    this.toggleDisableModal(status);
    this.togleEditWebhooksModal(status);
    this.togleCreateWebhooksModal(status);
    this.toggleEditClubDataModal(status);
    this.toggleEditClubCommunicationModal(status);
    this.toggleEditClubAddressModal(status);
    this.toggleEditClubBankDataModal(status);
    this.toggleEditTixxConnect(status);
    this.toggleEditCampaign(status);
    this.toggleEditTixxSelect(status);
    this.toggleEditWebsiteModal(status);
    this.toggleEditFanScoreCard(status);
    this.toggleEditCampaiMembership(status);
    this.toggleEditTixxWebshop(status);
    this.toggleEditClubGdprSettingsModal(status);
  }

  /**
   * Set the status of the edit club-overview modal.
   */
  public toggleEditClubModal(status: boolean): void {
    this.listOfModals.editClubModal = status;
  }

  /**
   * Set the status of the edit club-overview modal.
   */
  public toggleEditClubCommunicationModal(status: boolean): void {
    this.listOfModals.editClubCommunicationModal = status;
  }

  /**
   * Set the status of the edit club-overview modal.
   */
  public toggleEditClubAddressModal(status: boolean): void {
    this.listOfModals.editClubAddressModal = status;
  }

  /**
   * Set the status of the edit club-overview modal.
   */
  public toggleEditClubBankDataModal(status: boolean): void {
    this.listOfModals.editClubBankDataModal = status;
  }

  /**
   * Set the status of the edit club-overview modal.
   */
  public toggleEditTixxConnect(status: boolean): void {
    this.listOfModals.editTixxConnect = status;
  }

  /**
   * Set the status of the edit club-overview modal.
   */
  public toggleEditCampaign(status: boolean): void {
    this.listOfModals.editCampaign = status;
  }

  /**
   * Set the status of the edit club-overview modal.
   */
  public toggleEditTixxSelect(status: boolean): void {
    this.listOfModals.editTixxSelect = status;
  }

  /**
   * Set the status of the edit club-overview modal.
   */
  public toggleEditClubDataModal(status: boolean): void {
    this.listOfModals.editClubDataModal = status;
  }

  /**
   * Set the status of the edit logo modal.
   */
  public togleEditLogoModal(status: boolean): void {
    this.listOfModals.editLogoModal = status;
  }

  /**
   * Set the status of the edit products settings modal.
   */
  public togleEditModulesModal(status: boolean): void {
    this.listOfModals.editModulesModal = status;
  }

  /**
   * Set the status of the edit webhooks modal.
   */
  public togleEditWebhooksModal(status: boolean): void {
    this.listOfModals.editWebhookModal = status;
  }

  /**
   * Set the status of the create webhooks modal.
   */
  public togleCreateWebhooksModal(status: boolean): void {
    this.listOfModals.createWebhookModal = status;
  }

  /**
   * Set the status of the website modal.
   */
  public toggleEditWebsiteModal(status: boolean): void {
    this.listOfModals.editWebsiteModal = status;
  }

  /**
   * Set the status of the disable modal.
   */
  public toggleDisableModal(status: boolean): void {
    this.disableModal = status;
  }

  /**
   * Sets the current loading process to true of false
   */
  public toggleUpdateLoading(status: boolean): void {
    this.updateLoading = status;
  }

  /**
   * Sets the current loading process to true of false
   */
  public toggleEditFanScoreCard(status: boolean): void {
    this.listOfModals.editFanScoreCard = status;
  }

  /**
   * Sets the current loading process to true of false
   */
  public toggleEditTixxWebshop(status: boolean): void {
    this.listOfModals.editTixxWebshop = status;
  }

  /**
   * Sets the current loading process to true of false
   */
  public toggleEditCampaiMembership(status: boolean): void {
    this.listOfModals.editCampaiMembership = status;
  }

  public toggleEditClubGdprSettingsModal(status: boolean): void {
    this.listOfModals.editClubGdprSettingsModal = status;
  }

  /**
   * Checks which modal is opened based on true-false value of modals object
   */
  public checkWhichModalOpened(): any {
    const keys = Object.keys(this.listOfModals);
    let result;
    keys.filter(key => {
      if (this.listOfModals[key]) {
        result = key;
      }
    });
    return result;
  }

}
